import type { ClientType, SiteType } from '@logistech/ui-shared';

// Alignés sur les enums Zod du missions-service (routes/clients, routes/sites)
export const CLIENT_TYPE_LABELS: Record<ClientType, string> = {
  MINING: 'Mines',
  BTP: 'BTP',
  AGRO: 'Agro-industrie',
  TRANSIT: 'Transit',
  OTHER: 'Autre',
};

export const SITE_TYPE_LABELS: Record<SiteType, string> = {
  MINE: 'Mine',
  PORT: 'Port',
  WAREHOUSE: 'Entrepôt',
  CLIENT: 'Site client',
  DEPOT: 'Dépôt',
  OTHER: 'Autre',
};

export const apiErrorMessage = (err: unknown, fallback: string): string => {
  const e = (err as {
    response?: { data?: { error?: { message?: string; details?: { message: string }[] } } };
  })?.response?.data?.error;
  // Erreur de validation : le détail par champ est plus utile que « Validation échouée sur body »
  return e?.details?.length ? e.details.map((d) => d.message).join(' · ') : e?.message ?? fallback;
};
